var _ellipse, _ellipse2, _path, _circle, _path2, _path3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpeedometer = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.2594,
    cy: 33.6498,
    rx: 26.2594,
    ry: 26.6433,
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 6.9818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.2597,
    cy: 33.65,
    rx: 23.4853,
    ry: 23.8286,
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 6.9818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8242 47.9958C21.8242 46.0691 23.5949 44.6434 25.9656 44.5071C31.7013 44.1772 34.9158 44.1908 40.5529 44.5071C42.8277 44.6347 44.6943 46.0691 44.6943 47.9958C44.6943 49.9226 42.5719 51.6558 40.2847 51.6558C36.7988 51.827 32.0119 51.9815 26.3014 51.6558C24.0142 51.6558 21.8242 49.9226 21.8242 47.9958Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 6.9818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.3904,
    cy: 34.7201,
    r: 3.41973,
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 6.9818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8102 35.1378C36.8102 37.064 35.2791 38.6255 33.3904 38.6255C31.5018 38.6255 29.9707 37.064 29.9707 35.1378",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 6.9818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3088 31.881C40.3885 28.8168 43.7023 27.1352 48.9016 23.1967C43.7023 27.1352 41.0048 29.7994 37.0719 32.9656",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.4984,
    y1: 36.7584,
    x2: 17.312,
    y2: 36.0586,
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 6.9818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 14.4386,
    y1: 27.5251,
    x2: 17.1261,
    y2: 28.2588,
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 6.9818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 36.983,
    y1: 14.3859,
    x2: 36.4645,
    y2: 17.1231,
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 6.9818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 18.5422,
    y1: 20.2883,
    x2: 20.6254,
    y2: 22.138,
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 6.9818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 44.5215,
    y1: 17.9039,
    x2: 42.8426,
    y2: 20.127,
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 6.9818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 51.8387,
    y1: 29.5932,
    x2: 49.1259,
    y2: 30.2269,
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 6.9818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 26.3966,
    y1: 14.7771,
    x2: 27.6966,
    y2: 18.4299,
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 6.9818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 4.87728,
    y2: -1,
    transform: "matrix(-0.997256 -0.0740295 -0.0740295 0.997256 54.0859 38.1398)",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 6.9818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1475 48.0555C26.1475 47.7232 26.4667 47.4537 26.8605 47.4537H27.1401C27.5339 47.4537 27.8531 47.7232 27.8531 48.0555C27.8531 48.3879 27.5339 48.6573 27.1401 48.6573H26.8605C26.4667 48.6573 26.1475 48.3879 26.1475 48.0555Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 6.9818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3203 48.0555C30.3203 47.7232 30.6395 47.4537 31.0333 47.4537H31.313C31.7067 47.4537 32.026 47.7232 32.026 48.0555C32.026 48.3879 31.7067 48.6573 31.313 48.6573H31.0333C30.6395 48.6573 30.3203 48.3879 30.3203 48.0555Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 6.9818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4932 48.0555C34.4932 47.7232 34.8124 47.4537 35.2062 47.4537H35.4858C35.8796 47.4537 36.1988 47.7232 36.1988 48.0555C36.1988 48.3879 35.8796 48.6573 35.4858 48.6573H35.2062C34.8124 48.6573 34.4932 48.3879 34.4932 48.0555Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 6.9818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.666 48.0555C38.666 47.7232 38.9852 47.4537 39.379 47.4537H39.6587C40.0525 47.4537 40.3717 47.7232 40.3717 48.0555C40.3717 48.3879 40.0525 48.6573 39.6587 48.6573H39.379C38.9852 48.6573 38.666 48.3879 38.666 48.0555Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 6.9818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpeedometer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "speedometer.5fc830cafd1deda11bb304700f65f342.svg";